import {
  Modal, Form, Button, OverlayTrigger,
  Tooltip,
} from '@themesberg/react-bootstrap'
import { ErrorMessage, Formik } from 'formik'
import React from 'react'
import { reasonSchema } from '../../../Tenant/Users/schemas'
import { userDisableReasons } from '../constants'
import {

  faInfoCircle,

} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const DisableReason = ({
  show,
  handleClose,
  markUserStatusInactive,
  name
}) => {
  return (
    <>
      <Formik
        initialValues={{
          reason: '',
          description: ''
        }}
        validationSchema={reasonSchema}
        onSubmit={(formValues, { resetForm }) => {
          markUserStatusInactive(formValues)
          resetForm({ formValues: '' })
          handleClose()
        }}
      >
        {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => (
          <Modal
            show={show}
            onHide={handleClose}
            backdrop='static'
            keyboard={false}
            centered
            className="disable-reason-modal"
            style={{
              backdropFilter: "blur(15px)",
              WebkitBackdropFilter: "blur(15px)",
            }}
          >
            <Modal.Header className="border-bottom px-3 py-2 px-md-4 py-md-3 position-relative">
              <Modal.Title className="fs-6 fs-md-5 w-100 pe-4">
                <span className="d-block d-sm-inline">
                  Mark {name || 'Player'} In-Active
                </span>
              </Modal.Title>

              {/* Custom responsive close button */}
              <Button
                variant="link"
                className="p-0 border-0 bg-transparent text-dark position-absolute"
                onClick={handleClose}
                style={{
                  top: '50%',
                  right: '1rem',
                  transform: 'translateY(-50%)',
                  fontSize: '1.5rem',
                  lineHeight: '1',
                  minWidth: '32px',
                  minHeight: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textDecoration: 'none'
                }}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </Button>
            </Modal.Header>
            <Modal.Body>
              {/* <div className='form-group'>
                <label
                  htmlFor='reason'
                  className={touched.reason && errors.reason ? 'text-danger' : ''}
                >
                  Reason<span className='text-danger'> *</span>
                </label>
                <Form.Select
                  name='reason'
                  value={values.reason}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={touched.reason && errors.reason ? 'border border-danger' : ''}
                >
                  <option value=''>Select Reason</option>
                  {userDisableReasons.map(reason => <option value={reason} key={reason}>{reason}</option>)}
                </Form.Select>
                <ErrorMessage
                  component='div'
                  name='reason'
                  className='text-danger'
                />
              </div> */}
              <div className='form-group mt-3'>
                <label
                  htmlFor='reason'
                >
                  Reason  
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id={`tooltip`}>{"Please provide a valid reason (up to 100 characters)."}</Tooltip>
                    }
                  >
                    <span className="ms-2">
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="text-warning"
                      />
                    </span>
                  </OverlayTrigger>
                  <span className='text-danger'> *</span>                         

                </label>
                <Form.Control
                  name='reason'
                  as="textarea"
                  placeholder='Enter Reason'
                  value={values.reason}
                  onChange={handleChange}
                  className='reason-textarea '
                  onBlur={handleBlur}
                />
                <ErrorMessage
                  component='div'
                  name='reason'
                  className='text-danger'
                />
              </div>
            </Modal.Body>
            <div className='mt-4 '>
              <Modal.Footer className='d-flex justify-content-between align-items-center'>
                <Button
                  variant='outline-warning'
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant='outline-success'
                  onClick={handleSubmit}
                  className='ml-2'
                >
                  Submit
                </Button>
              </Modal.Footer>
            </div>
          </Modal>
        )}

      </Formik>
    </>
  )
}

export default DisableReason
